<template>
  <div class="wrapper">
    <div class="actBar">
      <div>
        <!-- <el-button type="primary" size="mini">导出学习记录</el-button> -->
        <el-button type="primary" plain size="mini">删除记录</el-button>
        <el-button type="primary" plain size="mini">未学习</el-button>
      </div>
      <div>
        <el-input
          placeholder="请输入学员关键字"
          v-model="searchCondition.name"
          size="mini"
        >
          <el-button slot="append" icon="el-icon-search"></el-button>
        </el-input>
      </div>
    </div>
    <div class="tableContainer">
      <el-table
        :data="dataList"
        @selection-change="
          (e) => {
            selectList = e;
          }
        "
        border
        style="width: 100%"
        ref="transformTable"
        :cell-style="{ padding: '8px 0', fontSize: '14px' }"
      >
        <el-table-column type="selection" width="40px"> </el-table-column>
        <el-table-column type="index" width="40px"> </el-table-column>
        <el-table-column prop="userName" label="学员" width="80px">
        </el-table-column>
        <!-- <el-table-column prop="userName" label="组" width="80px">
        </el-table-column> -->
        <el-table-column
          prop="learnProgressPercentage"
          label="学习进度"
          width="80px"
        >
        </el-table-column>
        <el-table-column
          prop="formatTotalLearnTime"
          label="学习总时长"
          width="180px"
        >
        </el-table-column>

        <el-table-column prop="lastLearnTime" label="最近学习时间">
        </el-table-column>

        <!-- <el-table-column align="center" width="400" label="操作">
          <template slot-scope="{ row }">
            <el-button slot="reference" size="small" @click="showLog(row)"
              >详细记录</el-button
            >
          </template>
        </el-table-column> -->
      </el-table>

      <el-pagination
        @current-change="getData"
        @size-change="getData"
        :current-page.sync="searchCondition.pageNumber"
        :page-sizes="[10, 30, 100]"
        :page-size.sync="searchCondition.pageSize"
        :total="searchCondition.total"
        layout="total, sizes, prev, pager, next, jumper"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { videoLearnRecord } from "@/api/bus.js";
export default {
  data() {
    return {
      searchCondition: {
        pageNumber: 1,
        pageSize: 20,
        catalogId: 0,
        total: 0,
      },
      dataList: [],
    };
  },
  props: {
    item: {
      type: Object,
      default: () => {
        return { id: 0 };
      },
    },
  },
  created() {},
  mounted() {
    this.searchCondition.catalogId = this.item.id;
    // this.searchCondition.catalogId = "1108336679470399489";
    this.getData();
  },
  methods: {
    getData() {
      videoLearnRecord(this.searchCondition).then((data) => {
        this.dataList = data.rows;
        this.searchCondition.total = data.total;
        console.log(data);
      });
    },
  },
};
</script>

<style scoped lang="less">
.wrapper {
  .actBar {
    display: flex;
    justify-content: space-between;
  }
}
</style>
